import { render, staticRenderFns } from "./CandidateItemExamHistoryItem.vue?vue&type=template&id=a825a8ae&scoped=true&lang=pug&"
import script from "./CandidateItemExamHistoryItem.vue?vue&type=script&lang=js&"
export * from "./CandidateItemExamHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateItemExamHistoryItem.vue?vue&type=style&index=0&id=a825a8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a825a8ae",
  null
  
)

export default component.exports